import { useQuery } from 'react-query'
import { getUser } from './user';
import { getUserGenres } from './genres';

const defaultOptions = { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false };
const mergedOptions = { ...defaultOptions };

function useFetchGetUser(userId: number) {
  return useQuery(
    ['user', userId],
    () => getUser(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false }
  );
}

function useFetchGetUserGenres(userId){
  return useQuery(
    ['genres'],
    () => getUserGenres(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false }
  );
}

export {
  useFetchGetUser,
  useFetchGetUserGenres
}